import { Button } from '@/ui/design-system/components/ui/button';
import { cn } from '@/ui/design-system/utils/cn';
import { forwardRef } from 'react';
import { withMixpanelClick } from 'utils/app';

const INTENT_TO_VARIANT = {
    primary: 'default',
    secondary: 'outline',
};

const TrackedIconButtonInner = forwardRef(function TrackedIconButtonInner(
    {
        IconLeft,
        IconRight,
        children,
        isDisabled,
        intent,
        wrapText = false,
        fetching,
        variant,
        size,
        mixpanelContext,
        className,
        ...props
    },
    ref,
) {
    return (
        <Button
            ref={ref}
            variant={variant || INTENT_TO_VARIANT[intent] || 'outline'}
            size={size || 'default'}
            disabled={!!isDisabled}
            loading={fetching}
            leftIcon={
                IconLeft ? (
                    <IconLeft className="!size-[1.2em] shrink-0 opacity-50" />
                ) : undefined
            }
            rightIcon={
                IconRight ? (
                    <IconRight className="!size-[1.2em] shrink-0 opacity-50" />
                ) : undefined
            }
            className={cn(wrapText && 'whitespace-normal', className)}
            {...props}
        >
            {children}
        </Button>
    );
});

const TrackedIconButton = withMixpanelClick(TrackedIconButtonInner, 'Button');

export default TrackedIconButton;
